import { styled, TextField } from '@mui/material';
import { COLOR_ACCENT, COLOR_RED } from 'shared';

export const ReferralInput = styled(TextField, {
  shouldForwardProp: (prop) => prop !== '$success' && prop !== '$error',
})<{ $success: boolean; $error: boolean }>(({ $error, $success }) => {
  // eslint-disable-next-line no-nested-ternary
  const inputColor = $success ? COLOR_ACCENT : $error ? COLOR_RED : undefined;
  return {
    flex: 1,
    height: '100%',
    '& .MuiInputBase-root': {
      border: 'none',
      ...(inputColor && {
        '& .MuiInputBase-input': {
          color: inputColor,
        },
      }),
    },
  };
});
